import type { ReactElement, ReactNode } from "react"
import { Link as GatsbyLink } from "gatsby"
import hasTelOrMailInLink from "@gatsby-plugin-generic-page/helpers/hasTelOrMailInLink"
import arrowRight from "@ionos-web-design-system/icon/system/arrow-right"
import { Icon, Link, type LinkProps } from "@ionos-web-design-system/react"
import isEmpty from "~/lib/isEmpty"

export type ArrowLinkProps = Pick<LinkProps, "href" | "title" | "onClick"> & {
  to?: string
  children: ReactNode
}

function ArrowLink({
  to,
  href,
  title,
  children,
  ...restProps
}: ArrowLinkProps): ReactElement<ArrowLinkProps> | null {
  const hrefWithMailOrTel = hasTelOrMailInLink(to)
  const resolvedTo = hrefWithMailOrTel ? undefined : to
  const resolvedHref = hrefWithMailOrTel || href

  if (isEmpty(resolvedTo) && isEmpty(resolvedHref)) return null

  if (!isEmpty(resolvedTo)) {
    return (
      <Link
        concept="mono"
        variant="inline"
        asChild
        className="text-base font-black"
        {...restProps}
      >
        <GatsbyLink to={resolvedTo} title={title}>
          {children}

          <Icon icon={arrowRight} size="small" className="ml-1" />
        </GatsbyLink>
      </Link>
    )
  }

  return (
    <Link
      href={resolvedHref}
      title={title}
      concept="mono"
      variant="inline"
      className="text-base font-black"
      {...restProps}
    >
      {children}

      <Icon icon={arrowRight} size="small" className="ml-1" />
    </Link>
  )
}

export default ArrowLink
